import {
  Avatar,
  Box,
  Stack,
  Typography,
  IconButton,
  Grid,
  FormControl,
  useMediaQuery,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import User from 'assets/icons/UserProfile.svg';
import Monetize from 'assets/icons/dollar.svg';
import BlueTick from 'assets/icons/blueTick.svg';
import Phone from 'assets/icons/callPhone.svg';
import Location from 'assets/icons/locationMap.svg';
import Mail from 'assets/icons/mail.svg';
import BuyerReadiness from 'assets/images/buyerReadiness.jpg';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import meter from 'assets/icons/meter.svg';
import { useTheme } from '@emotion/react';
import Loading from 'assets/images/loading.png';

import {
  poppins400,
  poppins300,
  poppins500,
  poppins600,
} from 'theme/common.style';
import { ExpandIcon, RightArrow } from 'component/OwnerCard/OwnerCard';
import NameTooltip from 'component/Common/NameTooltip';

const ToggleOn = () => {
  return (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.460938"
        width="41.54"
        height="24.3705"
        rx="12.1852"
        fill="url(#paint0_linear_9124_97512)"
      />
      <ellipse
        cx="30.0913"
        cy="12.1852"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9124_97512"
          x1="12.7341"
          y1="-1.66162"
          x2="18.2578"
          y2="28.3495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6C2AD2" />
          <stop offset="1" stop-color="#77CFFE" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const OwnerCardProfile = (props) => {
  const {
    showBackdrop,
    setSelectedBuyers,
    setSelectedBuyerId,
    openOwner,
    setOpenOwner,
    open,
    setOpen,
    userType,
    expand,
    setExpand,
    data,
    action,
    handleOptionChange,
    selectedBuyers,
    buyerId,
    setProfileDetails,
    fromSearch,
    catSelected,
    buyerpropertylist,
    loading,
    profileDetails,
  } = props;
  const [isHidden, setIsHidden] = useState(false);
  const theme = useTheme();
  const matches870 = useMediaQuery(theme.breakpoints.down(870));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  useEffect(() => {
    if (
      fromSearch &&
      buyerpropertylist?.length >= 1 &&
      profileDetails != {} &&
      !loading
    ) {
      setExpand(true);
      setIsHidden(true);
    }
  }, [buyerpropertylist, profileDetails]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '15px',
        width: matchessm ? '100%' : '365px',
        background: '#FFFFFF',
        //border:"1px solid red",
        borderRadius: '10px, 0px, 0px, 10px',
      }}
    >
      <Stack
        // spacing={7}
        direction={'row'}
        alignItems={'center'}
        //border={"3px solid orange"}
        justifyContent={expand ? 'right' : 'space-between'}
        sx={{
          margin: '0',
          width: '90%',
          height: matchessm ? '0px' : '30px',
          marginTop: matchessm ? '0px' : '10px',
        }}
      >
        {data?.user == null ? (
          <Box sx={{ width: '10px', height: '10px' }}></Box>
        ) : (
          <>
            {(isHidden && expand) || matchessm ? null : (
              <IconButton
                sx={{ zIndex: 1 }}
                onClick={() => {
                  setExpand(!expand);
                  setIsHidden(true);
                }}
              >
                <ExpandIcon />
              </IconButton>
            )}
          </>
        )}

        {userType === 'Both' && !matchessm && (
          <Stack
            justifyContent={'space-around'}
            direction={'row'}
            alignItems={'center'}
            spacing={2}
            position={'absolute'}
            sx={{ marginLeft: '2px', margin: '1px', marginTop: '-1px' }}
          >
            <Typography
              sx={{
                ...poppins400,
                fontSize: '12px',
                color: '#9C9C9C',
                marginLeft: '90px',
              }}
            >
              Buyer
            </Typography>
            <Typography
              onClick={() => {
                setOpen(!open);
                setOpenOwner(!openOwner);
              }}
              style={{
                cursor: 'pointer',
                marginTop: '5px',
                marginLeft: '15px',
              }}
            >
              <ToggleOn />
            </Typography>
            <Typography
              sx={{
                ...poppins400,
                fontSize: '12px',
                color: '#112347',
                marginLeft: '90px',
              }}
            >
              Owner
            </Typography>
          </Stack>
        )}

        <>
          {!matchessm &&
          (!expand || matches870) &&
          (showBackdrop || !showBackdrop) ? (
            <IconButton
              onClick={() => {
                setOpen(!open);
                setProfileDetails({});
                setSelectedBuyerId('');
                {
                  showBackdrop &&
                    setSelectedBuyers((prevBuyers) => {
                      const filter = selectedBuyers.filter(
                        (buyer) => buyer != buyerId
                      );
                      // const newBuyers = [...prevBuyers];
                      // newBuyers.splice(newBuyers.length - 1, 1);
                      return filter;
                    });
                }
              }}
              sx={{
                position: 'relative',
                //left : matches870 && "280px",
              }}
            >
              <RightArrow />
            </IconButton>
          ) : null}
        </>
      </Stack>

      <Box
        sx={{
          width: matchessm ? '100%' : 'auto',
          height: '110px',
          position: 'relative',
        }}
      >
        <Stack
          sx={{
            //border:"1px solid red",
            width: matchessm ? '100%' : '327px',
            height: '67px',
            marginTop: '5px',
            borderRadius: '10px',
            background: `linear-gradient(180deg, rgba(108, 42, 210, 0.5) 0%, rgba(117, 184, 247, 0.5) 100%)`,
          }}
          justifyContent={'center'}
          alignItems={'center'}
          display={'-webkit-inline-flex'}
        >
          {data?.user?.userProfile == '' || data?.user?.userProfile == null ? (
            <Avatar
              style={{
                height: '91px',
                width: '91px',
                fontFamily: 'poppins',
                marginTop: '60px',
                backgroundColor: '#666666',
                fontSize: '40px',
                border: '4px solid #FFFFFF',
              }}
            >
              {loading
                ? ''
                : data?.user?.userName?.charAt(0)?.toUpperCase() +
                  data?.user?.userSurName?.charAt(0)?.toUpperCase()}
            </Avatar>
          ) : (
            <Avatar
              style={{
                height: '91px',
                width: '91px',
                border: '4px solid #FFFFFF',
                marginTop: '60px',
              }}
              src={data?.user?.userProfile}
            />
          )}
        </Stack>
      </Box>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          width: '335px',
          height: '30px',
          padding: '0px',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'calc(100% - 70px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minWidth: 0,
          }}
        >
          <NameTooltip
            name={data?.user?.userName || ''}
            surname={data?.user?.userSurName || ''}
          >
            <Typography
              sx={{
                ...poppins600,
                fontSize: '20px',
                color: '#000000',
                display: 'block',
                width: '100%',
                minWidth: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                cursor: 'pointer',
                textAlign: 'center',
              }}
            >
              {`${data?.user?.userName || ''} ${
                data?.user?.userSurName || ''
              }`.trim()}
            </Typography>
          </NameTooltip>
        </Box>

        <Box
          sx={{
            marginLeft: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            flexShrink: 0,
          }}
        >
          <Avatar
            alt=""
            src={BlueTick}
            sx={{
              height: '16px',
              width: '16px',
              flexShrink: 0,
            }}
          />

          <Avatar
            alt=""
            src={Monetize}
            sx={{
              height: '16px',
              width: '16px',
              flexShrink: 0,
            }}
          />
        </Box>
      </Box>
      {expand && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0px',

            width: '221px',
            height: '18px',
          }}
        >
          <Typography
            sx={{ ...poppins400, fontSize: '12px', color: '#585858' }}
          >
            Buyer Readiness
          </Typography>
          <Avatar
            alt="BuyerReadiness"
            src={BuyerReadiness}
            sx={{ height: '10px', width: '107.5px', borderRadius: '5px' }}
          />
        </Box>
      )}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: '10px',
          width: matchessm ? '100%' : '340px',
          height: '146px',
          border: '1px solid #E7E5E5',
          borderRadius: '8px',
          justifyContent: 'space-between',
        }}
      >
        {loading ? (
          <Grid
            sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '160px 0',
            }}
          >
            <img
              alt="Logo"
              src={Loading}
              className="loaderImage"
              style={{ height: '50px', width: '50px' }}
            />
          </Grid>
        ) : (
          <Box sx={{ overflowWrap: 'anywhere' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Avatar
                src={Phone}
                sx={{
                  borderRadius: '0px',
                  // p: "3px",
                  width: '30px',
                  height: '30px',
                  marginBottom: '10px',
                }}
              />

              <Typography
                sx={{
                  ...poppins400,
                  fontSize: '12px',
                  color: '#585858',
                  marginLeft: '17px',
                  marginTop: '6px',
                }}
              >
                {data?.userMobile}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Avatar
                src={Mail}
                sx={{
                  borderRadius: '0px',
                  // p: "3px",
                  width: '30px',
                  height: '30px',
                  marginBottom: '10px',
                }}
              />
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: '12px',
                  color: '#585858',
                  marginLeft: '17px',
                  marginTop: '6px',
                }}
              >
                {data?.userEmail}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Avatar
                src={Location}
                sx={{
                  borderRadius: '2px',
                  // p: "3px",
                  width: '30px',
                  height: '30px',
                }}
              />
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: '12px',
                  color: '#585858',
                  marginLeft: '17px',
                  marginTop: '8px',
                }}
              >
                {data?.userAddress ? data?.userAddress : 'Address not found'}
              </Typography>
            </Box>
          </Box>
        )}
        {!expand && (
          <Grid item xs={4}>
            <Stack direction={'column'} spacing={1.1}>
              <FormControl sx={{ minWidth: '60px' }} size="small">
                <Select
                  id="optionlist"
                  sx={{
                    ...poppins500,
                    fontSize: '12px',
                    fontColor: '#112347',
                    border: '1px solid #6C2AD2',
                    width: '100px',
                    height: '30px',
                    borderRadius: '6px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                  }}
                  // size="medium"
                  value={action}
                  label="Action"
                  onChange={(e) =>
                    handleOptionChange(e, data?.propertyDetails[0])
                  }
                  displayEmpty
                  inputProps={{
                    'aria-label': 'Without label',
                  }}
                  // onClick={() => {
                  //   setOpendialog(true);
                  // }}
                >
                  <MenuItem
                    value={''}
                    sx={{
                      ...poppins500,
                      fontSize: '12px',
                      color: '#112347',
                    }}
                  >
                    Action
                  </MenuItem>
                  <MenuItem
                    value={10}
                    sx={{
                      ...poppins500,
                      fontSize: '12px',
                      color: '#112347',
                    }}
                  >
                    Insights
                  </MenuItem>
                  <MenuItem
                    value={20}
                    sx={{
                      ...poppins500,
                      fontSize: '12px',
                      color: '#112347',
                    }}
                  >
                    Buyer Match
                  </MenuItem>
                </Select>
              </FormControl>
              <Typography
                variant="caption"
                sx={{
                  ...poppins400,
                  fontSize: '8px',
                  // width: "50px",
                  textAlign: 'center',
                  marginTop: '0px',
                  color: '#585858',
                }}
              >
                Relationship Score
              </Typography>
              <Box sx={{ marginTop: '0px' }}>
                <img
                  src={meter}
                  alt=""
                  style={{
                    width: '69px',
                    height: '42px',
                    marginLeft: '15px',
                  }}
                />
                {/* <RelationShipScore /> */}
              </Box>

              <Box sx={{ marging: '0px' }}>
                <Typography
                  variant="caption"
                  sx={{
                    ...poppins300,
                    fontSize: '8px',
                    width: '50px',
                    // textAlign: "center",
                    color: '#585858',
                    marginLeft: '28px',
                  }}
                >
                  Weak
                </Typography>
              </Box>
            </Stack>
          </Grid>
        )}
        {expand && (
          <>
            <Grid item xs={4}>
              <Stack direction={'column'} spacing={1.1}>
                <Box sx={{ marginTop: '21px' }}>
                  <img
                    src={meter}
                    alt=""
                    style={{
                      width: '69px',
                      height: '42px',
                      marginLeft: '8px',
                    }}
                  />
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    ...poppins400,
                    fontSize: '12px',
                    // width: "50px",
                    textAlign: 'center',
                    marginTop: '0px',
                    color: '#585858',
                  }}
                >
                  Relationship Score
                </Typography>
              </Stack>
            </Grid>
          </>
        )}
      </Box>
    </Box>
  );
};
